import { useMemo, useState } from "react";
import { Search } from "lucide-react";
import { Input } from "../components/ui/input";
import catalog from "../data/catalog.json";
import { fmtEUR } from "../lib/storage";

export default function Catalog() {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("Todas");

  const cats = useMemo(() => ["Todas", ...Array.from(new Set(catalog.map((c) => c.categoria)))], []);

  const filtered = useMemo(() => {
    const term = q.trim().toLowerCase();
    return catalog.filter((c) => {
      if (cat !== "Todas" && c.categoria !== cat) return false;
      if (!term) return true;
      return (
        c.descripcion.toLowerCase().includes(term) ||
        c.codigo.toLowerCase().includes(term) ||
        c.categoria.toLowerCase().includes(term)
      );
    });
  }, [q, cat]);

  return (
    <div className="px-10 py-10 max-w-7xl mx-auto" data-testid="catalog-page">
      <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-2">
        Base de precios
      </div>
      <h1 className="text-4xl sm:text-5xl font-display font-bold tracking-tight">
        Catálogo de partidas.
      </h1>
      <p className="text-slate-500 mt-2 max-w-2xl">
        Datos mock representativos del Generador de Precios — útil como referencia para la IA y para edición manual.
      </p>

      <div className="flex flex-wrap gap-3 mt-8 mb-5">
        {cats.map((c) => (
          <button
            key={c}
            type="button"
            onClick={() => setCat(c)}
            data-testid={`catalog-cat-${c}`}
            className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors ${
              cat === c
                ? "bg-blue-600 text-white border-blue-600"
                : "bg-white text-slate-600 border-slate-200 hover:border-slate-400"
            }`}
          >
            {c}
          </button>
        ))}
      </div>

      <div className="rx-card overflow-hidden">
        <div className="px-5 py-4 border-b border-slate-200 flex items-center justify-between">
          <div className="text-sm text-slate-500">{filtered.length} partidas</div>
          <div className="relative w-72 max-w-full">
            <Search className="w-4 h-4 absolute left-3 top-2.5 text-slate-400" />
            <Input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Buscar…"
              className="pl-9 h-9"
              data-testid="catalog-search"
            />
          </div>
        </div>
        <div className="divide-y divide-slate-100 max-h-[640px] overflow-y-auto">
          {filtered.map((c) => (
            <div key={c.codigo} className="px-5 py-3 grid grid-cols-12 gap-3 items-center" data-testid={`catalog-row-${c.codigo}`}>
              <div className="col-span-1 font-mono text-xs text-slate-400">{c.codigo}</div>
              <div className="col-span-7 text-sm text-slate-800">{c.descripcion}</div>
              <div className="col-span-2 text-xs text-slate-500">{c.categoria}</div>
              <div className="col-span-1 text-xs text-slate-500 text-center">{c.unidad}</div>
              <div className="col-span-1 text-right text-sm font-semibold text-blue-600">
                {fmtEUR(c.precio_unitario)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
